import { OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { AbstractMerchantSupplierComponent } from "app/core/common/abstract.merchant-supplier.component";
import { MerchantService } from "app/core/services/merchant.service";
import { PosService } from "app/core/services/pos.service";
import { SupplierService } from "app/core/services/supplier.service";
import { NGXLogger } from "ngx-logger";





export abstract class AbstractModalContentComponent extends AbstractMerchantSupplierComponent implements OnInit{
    
    protected supplierService: SupplierService;
    protected merchantService: MerchantService;
    protected translate: TranslateService;
    protected posService : PosService;
    public log : NGXLogger;
    public activeModal: NgbActiveModal;
    public router : Router;
    protected abstractmerchantsupplier : AbstractMerchantSupplierComponent;
    
      public ngOnInit(): void {
        this.getMerchants();
        this.getSuppliers();
      }
    
      quit() {
        this.activeModal.close();
      }

      getStrMultiLignes(chaine, tailleLigne, toAppend) {
        tailleLigne = parseInt(tailleLigne, 10) || 76;
        toAppend = toAppend || '\r\n';
        if (tailleLigne < 1) {
          return false;
        }
        return chaine.match(new RegExp(".{0," + tailleLigne + "}", "g")).join(toAppend);
      }
    
      date() {
        let frDateFormat = "dd MMM y, H:mm";
        let usDateFormat = "MMM dd y, hh:mm a";
        if (this.translate.currentLang == "fr_FR")
          return frDateFormat;
        else
          return usDateFormat;
    
      }
    
      locale() {
        if (this.translate.currentLang == "fr_FR")
          return "fr_FR";
        else
          return "en_US";
      }
    }
